import {FormattedMessage} from "react-intl";
import React from "react";
import { DIGITAL_JOBS_ROUTE, JOBS_ROUTE, CASE_STUDIES_ROUTE } from '../../../constants/routePaths'
import LocaleLink from "../../Routes/LocaleLink";

export const faqCardsBody = (index) => {
    switch (index){
        case 1:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_1.body.paragraph_1"
                            defaultMessage="" />
                    </p>

                    {/* question 2  */}
                    <div>
                        <p className="faq-card-body-title">
                            <FormattedMessage
                                id="faq.open_application.questions.question_2.title"
                                defaultMessage="" />
                        </p>
                    </div>
                    <div>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_2.body.paragraph_1"
                                defaultMessage="" />
                        </p>
                        <ul>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_1"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_2"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_3"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_4"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_5"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_6"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_7"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_8"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_9"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_10"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_11"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_12"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_13"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_14"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_15"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_16"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_17"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_18"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_2.body.list_item_19"
                                    defaultMessage="" />
                            </li>
                        </ul>
                    </div>

                    {/* question 3  */}
                    <div className="faq-card-body-title">
                        <FormattedMessage
                        id="faq.open_application.questions.question_3.title"
                        defaultMessage="" />
                    </div>
                    <div>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_3.body.paragraph_1"
                                defaultMessage="" />
                        </p>
                        <ul>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_1"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_2"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_3"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_4"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_5"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_6"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_7"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_8"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_9"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_10"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_11"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_12"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_13"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_3.body.list_item_14"
                                    defaultMessage="" />
                            </li>
                        </ul>
                    </div>

                    {/* question 4  */}
                    <div className="faq-card-body-title">
                        <FormattedMessage
                            id="faq.open_application.questions.question_4.title"
                            defaultMessage="" />
                    </div>
                    <div>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_4.body.paragraph_1"
                                defaultMessage="" />
                        </p>
                        <ul>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_4.body.list_item_1"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_4.body.list_item_2"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_4.body.list_item_3"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_4.body.list_item_4"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_4.body.list_item_5"
                                    defaultMessage="" />
                            </li>
                        </ul>
                    </div>

                    {/* question 5  */}
                    <div className="faq-card-body-title">
                        <FormattedMessage
                            id="faq.open_application.questions.question_5.title"
                            defaultMessage="" />
                    </div>
                    <div>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_5.body.paragraph_1"
                                defaultMessage="" />
                        </p>
                        <ul>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_1"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_2"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_3"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_4"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_5"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_6"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_7"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_8"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_9"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_5.body.list_item_10"
                                    defaultMessage="" />
                            </li>
                        </ul>
                    </div>

                    {/* question 6  */}
                    <div className="faq-card-body-title">
                        <FormattedMessage
                            id="faq.open_application.questions.question_6.title"
                            defaultMessage="" />
                    </div>
                    <div>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_6.body.paragraph_1"
                                defaultMessage="" />
                        </p>

                        <ul>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.list_item_1"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.list_item_2"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.list_item_3"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.list_item_4"
                                    defaultMessage="" />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.list_item_5"
                                    defaultMessage="" />
                            </li>
                        </ul>
                        <p>
                            <br/>
                            <FormattedMessage
                                id="faq.open_application.questions.question_6.body.paragraph_2"
                                defaultMessage="" />

                            <LocaleLink to={JOBS_ROUTE}>
                                <FormattedMessage
                                    id="faq.open_application.questions.question_6.body.link_1"
                                    defaultMessage="" />
                            </LocaleLink>
                        </p>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_6.body.paragraph_3"
                                defaultMessage="" />
                        </p>
                        <p>
                            <FormattedMessage
                                id="faq.open_application.questions.question_6.body.paragraph_4"
                                defaultMessage="" />
                        </p>
                    </div>

                </div>
            )
        case 2:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_7.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_7.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.open_application.questions.question_7.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.open_application.questions.question_7.body.list_item_2"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_7.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 3:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_8.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_8.body.paragraph_2"
                            defaultMessage="" />

                        <LocaleLink to={`${CASE_STUDIES_ROUTE}/la-plateforme-digital-de-recrutement-dhunteed-1618322628`}>
                            <FormattedMessage
                                id="faq.open_application.questions.question_8.body.link_1"
                                defaultMessage="" />
                        </LocaleLink>
                    </p>
                </div>
            )
        case 4:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_9.body.paragraph_1"
                            defaultMessage="" />

                        <LocaleLink to={DIGITAL_JOBS_ROUTE}>
                            <FormattedMessage
                                id="faq.open_application.questions.question_9.body.link"
                                defaultMessage="" />
                        </LocaleLink>&nbsp;

                        <FormattedMessage
                            id="faq.open_application.questions.question_9.body.paragraph_4"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_9.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_9.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 5:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <br/>
                    <p>
                        <strong>
                            <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_3_title"
                            defaultMessage="" />
                        </strong>

                        <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_4"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.open_application.questions.question_10.body.paragraph_5"
                            defaultMessage="" />
                    </p>
                </div>
            )

        default:
            return (<></>)
    }
}

export const faqCardsHeader = (index) => {
    switch (index){
        case 1:
            return (<FormattedMessage
                id="faq.open_application.questions.question_1.title"
                defaultMessage="Comment trouver un métier dans le digital qui vous convienne ?" />)
        case 2:
            return (<FormattedMessage
                id="faq.open_application.questions.question_7.title"
                defaultMessage="" />)
        case 3:
            return (<FormattedMessage
                id="faq.open_application.questions.question_8.title"
                defaultMessage="" />)
        case 4:
            return (<FormattedMessage
                id="faq.open_application.questions.question_9.title"
                defaultMessage="" />)
        case 5:
            return (<FormattedMessage
                id="faq.open_application.questions.question_10.title"
                defaultMessage="" />)

        default:
            return (<FormattedMessage
                id="faq.open_application.title"
                defaultMessage="Nous répondons à vos questions" />)
    }
}
